import React, { useState, useEffect } from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ text = 'Loading...' }) => {
  const [showSlowMessage, setShowSlowMessage] = useState(false);
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    const slowTimer = setTimeout(() => setShowSlowMessage(true), 7000);
    const reloadTimer = setTimeout(() => setShowReload(true), 11000);

    return () => {
      clearTimeout(slowTimer);
      clearTimeout(reloadTimer);
    };
  }, []);

  return (
    <div className="loading-spinner-container">
      <div className="spinner-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <p className="loading-text">{text}</p>
      {showSlowMessage && (
        <p className="slow-loading-message">
          This takes longer than expected. Hang tight!
        </p>
      )}
      {showReload && (
        <>
          <p className="slow-loading-message">
            OR
          </p>
          <button className="reload-page-btn" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </>
      )}
    </div>
  );
};

export default LoadingSpinner;
